export enum Permission {
  Sandbox = 'sandbox.modify',
  // Gates links into the storefront-onboarding domain, which requires this permission.
  StorefrontOnboarding = 'storefront_onboarding.modify',
}
